/* 
  Мидлвара добавляющая "/" в конце маршрута
  Если в url содержится query параметр - добавлять "/" в конце не нужно (Требование СЕО)
*/
export default defineNuxtRouteMiddleware(({ path, query, hash }) => {
  // Регулярное выражение для определения изображений формата PNG и JPG
  const imageRegex = /\.(png|jpg|jpeg|svg|webp)$/i

  // Убираем лишние слэши, чтобы путь воспринимался внутренним для nuxt
  const normalizedPath = path.includes('//')
    ? path.replace(/\/{2,}/g, '/')
    : path

  if (
    normalizedPath === '/' ||
    normalizedPath.endsWith('/') ||
    Object.keys(query).length !== 0 ||
    imageRegex.test(normalizedPath)
  )
    return

  const nextPath = normalizedPath + '/'
  const nextRoute = { path: nextPath, query, hash }

  return navigateTo(nextRoute, { redirectCode: 308 })
})
